module.exports = __webpack_public_path__ + "media/images/select-arrow-f61b5921900a33f4777a9d7452121704.svg";